import type { TestStepProps } from 'src/suitability/engine/types';
import { BLOCK1_QUESTIONS, type ConsilioAnswers } from './answers';
import { ScoredBlock } from './scored-block';

export const StepBlock1 = (props: TestStepProps<ConsilioAnswers>) => (
  <ScoredBlock {...props} stepKey="block1" questions={BLOCK1_QUESTIONS} />
);
